import React from 'react';
import './services.css';
import bgservices from '../images/bgservices.webp';
import ArrowRight from './ArrowRights.js';
import ServicesList from './ServicesList.js';

function Services() {
  return (
    <section className='servicios' style={{ backgroundImage: `url(${bgservices})` }} name='services'>
        <div className='content'>
        <div className='flexIndex'>
                <p className='subtitles'>Generamos experiencias <strong>digitales</strong></p>
                <div className='titles'>
                    <h2>WHAT<em>_</em>WE<em>_</em>DO <sub>-</sub></h2>
                    <ArrowRight className="custom-arrow" />
                    <span className='bajada'>Impulsa tu Marca al <strong>Siguiente Nivel</strong></span>
                </div>
                <div className='colIndex colIndexData'>
                    <ServicesList />
                </div>
            </div> 
        </div>
    </section>
  );
}
export default Services;